module.exports = __webpack_public_path__ + "img/7_162.f559aff0.png";